






































import Vue from 'vue';
import axios from '@/plugins/axios';
import CtrlNumTxt from '@/components/common/control/CtrlNumTxt.vue';
import CtrlSearchBtn from '@/components/common/control/CtrlSearchBtn.vue';
import ListDaibunrui from '@/components/common/search/ListDaibunrui.vue';
import { API_SEARCH_DAIBUNRUI } from '@/constants/api';
import { noDataError, clearNoDataError } from '@/utils/message';

export default Vue.extend<any, any, any, any>({
  name: 'CtrlDaibunrui',
  props: {
    callbackCancel: {
      type: Function,
    },
    callbackOk: {
      type: Function,
    },
    label: {
      type: String,
      default: '品目大分類',
    },
    widthCd: {
      type: Number,
      default: 99, //21,
    },
    widthName: {
      type: Number,
      default: 204,
    },
    required: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    mukoUmuFlg: {
      type: Number,
    },
  },
  components: {
    CtrlNumTxt,
    CtrlSearchBtn,
    ListDaibunrui,
  },
  data: () => ({
    API_SEARCH_DAIBUNRUI,
    listDaibunruiShow: false,
    daibunruiCd: 0,
    daibunruiMei: '',
    errors: {
      errorMessages: '',
    },
    isNoData: false,
  }),
  computed: {
    styleItemName() {
      return {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: `${this.widthName}px`,
        color: 'rgba(0, 0, 0, 0.87)',
        cursor: 'default',
      };
    },
  },
  methods: {
    handleOk(item: { daibunruiCd: number; daibunruiMei: string }) {
      const { daibunruiCd, daibunruiMei } = item;
      this.daibunruiCd = daibunruiCd;
      this.daibunruiMei = daibunruiMei;
      this.listDaibunruiShow = false;
      this.errors.errorMessages = '';
      this.callbackOk && this.callbackOk(item);
      this.isNoData = false;
    },
    handleCancel() {
      this.listDaibunruiShow = false;
      this.callbackCancel && this.callbackCancel();
    },
    handleChange(value: number) {
      this.daibunruiCd = value;
      if (value) {
        this.getDaibunruiItem();
      } else {
        this.daibunruiMei = '';
        this.errors = clearNoDataError();
        // IDをクリアするとデータをリセットする
        this.callbackOk && this.callbackOk({ daibunruiCd: this.daibunruiCd });
      }
    },
    getDaibunruiItem() {
      axios
        .get(API_SEARCH_DAIBUNRUI, {
          params: {
            daibunruiCd: this.daibunruiCd,
            mukoUmuFlg: this.mukoUmuFlg,
          },
        })
        .then((res) => {
          if (!res.data.responseData || res.data.responseData.length === 0) {
            this.daibunruiMei = '';
            this.isNoData = true;
            this.errors = noDataError();
            this.callbackOk &&
              this.callbackOk({ daibunruiCd: this.daibunruiCd });
            return;
          }
          this.errors = clearNoDataError();
          const { daibunruiMei } = res.data.responseData[0];
          // console.log(daibunruiMei);
          this.daibunruiMei = daibunruiMei;
          this.callbackOk && this.callbackOk(res.data.responseData[0]);
          this.isNoData = false;
        });
    },
  },
  watch: {
    // 呼び出し元の tag の 引数 [daibunruiCd] に bind している変数 を監視する
    // 変数が、input 以外の event で値変更された時に、その値を control に set
    '$attrs.daibunruiCd': {
      handler(newValue) {
        if (+newValue === +this.daibunruiCd) return;
        this.daibunruiCd = +newValue;
        if (newValue) {
          this.getDaibunruiItem();
        } else {
          this.daibunruiMei = '';
          this.errors = clearNoDataError();
        }
      },
    },
  },
  created() {
    if (this.$attrs.daibunruiCd) {
      this.daibunruiCd = +this.$attrs.daibunruiCd;
    }
  },
});
